import { MicIcon, EyeIcon, BatteryFullIcon } from "lucide-react"

export default function Features() {
  return (
    <section className="h-screen flex flex-col justify-center items-center">
      <h2 className="text-3xl lg:text-4xl font-light tracking-wider uppercase mb-12 lg:mb-16">
        Revolutionary Features
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 w-full">
        <FeatureCard
          icon={<MicIcon size={40} />}
          title="Advanced Speech Recognition"
          description="Cutting-edge AI for accurate real-time transcription"
        />
        <FeatureCard
          icon={<EyeIcon size={40} />}
          title="Intuitive Display"
          description="Crystal clear text overlay for seamless reading"
        />
        <FeatureCard
          icon={<BatteryFullIcon size={40} />}
          title="All-Day Battery"
          description="Long-lasting power for uninterrupted use"
        />
      </div>
    </section>
  )
}

function FeatureCard({ icon, title, description }) {
  return (
    <div className="flex flex-col items-center text-center p-6 lg:p-8 rounded-lg transition-all duration-300 hover:bg-white/5">
      <div className="mb-4 lg:mb-6 text-white/80">{icon}</div>
      <h3 className="text-lg lg:text-xl font-light tracking-wide mb-2 lg:mb-4 uppercase">{title}</h3>
      <p className="text-sm lg:text-base text-gray-400 font-light">{description}</p>
    </div>
  )
}

